module.exports = __webpack_public_path__ + "static/img/login-bg.f5edbb8f.png";